import { useEffect } from "react";
import RequestForm from "@/pages/contact/RequestForm";
import { V2_FEEDBACK_FORM } from "@/pages/contact/requestFormsContent";
import { trackEvent } from "@/analytics/ga";
import { useSearchParams } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

/**
 * V2 feedback route (Phase 24).
 *
 * Routes:
 *   - `/contact/v2-feedback`    (English)
 *   - `/ar/contact/v2-feedback` (Arabic)
 *
 * Delegates rendering to the shared `<RequestForm />` using the
 * `V2_FEEDBACK_FORM` spec. The spec's flags (`contactOptional`,
 * `eventNames`, `suggestionCategoryField`) tell the form to:
 *   - allow anonymous submission (name + contact optional)
 *   - fire `v2_feedback_submit` on success (instead of `contact_submit`)
 *   - include the safe `suggestion_category` value in the GA event
 *   - propagate any `?source=v2_article|v2_banner` query param through
 *     to the backend for admin attribution
 *
 * This page's own responsibility is a single `v2_feedback_open` event on
 * mount, tagged with the safe `source` parameter for the funnel report.
 */
export default function V2FeedbackRequest() {
  const [params] = useSearchParams();
  const source = params.get("source") || "";
  const { lang } = useLanguage();

  useEffect(() => {
    // GA4 funnel: intent event. `source` distinguishes visitors who
    // opened the form from the announcement bar vs. from the article
    // page. Safe params only per the spec — no PII.
    trackEvent("v2_feedback_open", {
      language: lang,
      source: source || "",
    });
  }, [lang, source]);

  return <RequestForm spec={V2_FEEDBACK_FORM} />;
}
